import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";

@Component({
    selector: "alert-dialog",
    templateUrl: "alert.component.html",
    styleUrls: ["./alert.component.scss"],
    standalone: false
})
export class AlertDialogComponent {
  message: string = "";
  detail: string = "";
  faExclamationTriangle = faExclamationTriangle;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AlertDialogComponent>
  ) {
    if (data) {
      this.message = data.message || this.message;
      this.detail = data.detail || this.detail;
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
